@if (certificate(); as item) {
  <main class="public-verification-page">
    <section class="public-verification-hero">
      <div>
        <span class="public-verification-eyebrow">DriveMe Academy</span>
        <h1>Zertifikat prüfen</h1>
        <p>Dieser Nachweis wurde im DriveMe Academy Portal gefunden und kann hier online verifiziert werden.</p>
      </div>
      <div class="public-verification-seal" [class.invalid]="!item.valid">
        <span>{{ item.valid ? '✓' : '!' }}</span>
        <strong>{{ item.valid ? 'Gültig' : statusLabel(item.status) }}</strong>
      </div>
    </section>

    <section class="public-verification-card">
      <div class="public-verification-card-heading">
        <div>
          <span class="kicker">Online verifizierter Nachweis</span>
          <h2>Teilnahmebestätigung</h2>
        </div>
        <span class="status-pill" [class.success]="item.valid" [class.danger]="!item.valid">
          {{ item.valid ? 'Status bestätigt' : statusLabel(item.status) }}
        </span>
      </div>

      <div class="public-verification-main-fact">
        <span>Teilnehmer/in</span>
        <strong>{{ item.participantName }}</strong>
      </div>

      <div class="public-verification-grid">
        <div>
          <span>Schulung / Kurs</span>
          <strong>{{ item.courseTitle }}</strong>
        </div>
        <div>
          <span>Zertifikatsnummer</span>
          <strong>{{ item.certificateNumber }}</strong>
        </div>
        <div>
          <span>Ausgestellt am</span>
          <strong>{{ formatDate(item.issuedAt) }}</strong>
        </div>
        <div>
          <span>Gültig bis</span>
          <strong>{{ formatDate(item.validUntil) }}</strong>
        </div>
      </div>

      <div class="public-verification-note">
        <span class="public-verification-note-icon">✓</span>
        <p>Maßgeblich ist der aktuell im Portal hinterlegte Status dieses Zertifikats.</p>
      </div>
    </section>
  </main>
} @else if (error()) {
  <main class="public-verification-page">
    <section class="public-verification-error panel">
      <span class="public-verification-note-icon">!</span>
      <h1>Zertifikat nicht gefunden</h1>
      <p>Der Prüfcode ist ungültig oder der Nachweis ist nicht mehr verfügbar.</p>
    </section>
  </main>
} @else {
  <main class="public-verification-page">
    <div class="empty">Zertifikatsdaten werden geprüft.</div>
  </main>
}
